<template>
  <div class="ScrollableCard">
    <div class="ScrollableCard__track">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.ScrollableCard {
  position: relative;

  border: solid 2px var(--themeColorNeutral900);
  border-radius: 8px;
  background-color: var(--themeColorWhite);
}

.ScrollableCard__track {
  position: absolute;
  inset: 0;

  overflow-y: auto;

  border-radius: 6px;
}
</style>
